import Rete from "rete";
import VueProgressControl from "./ProgressControl.vue";

export class ProgressControl extends Rete.Control {
  constructor(emitter, key) {
    super(key);
    this.render = "vue";
    this.component = VueProgressControl;
    this.props = { emitter, ikey: key};
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}